import React, { useRef } from 'react';
import i18n from 'i18next';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import { withStyles } from '@material-ui/core/styles';
import { FormHelperText } from '@material-ui/core';

import { toActiveLocale } from '../../../../services/Translation';

function DocumentsRow({
  supportingDocumentsProps,
  supportingDocumentsState,
  handleFileUpload,
  docSpec,
  classes,
  t,
  type = 0,
}) {
  const inputEl = useRef(null);

  const {
    readOnly,
    pictureFileTypes,
    fileTypes,
    lang,
    documentMap,
  } = supportingDocumentsProps;
  const { idError, errorText } = supportingDocumentsState;

  const doc = documentMap[docSpec.uuid] || {};
  const isError = idError === docSpec.uuid;

  function getTranslatedError(translationKey) {
    if (!i18n.exists(translationKey || '')) {
      return '';
    }
    if (translationKey === 'unsupportedImageFileType') {
      return i18n.t('unsupportedImageFileType', { pictureFileTypes });
    }
    if (translationKey === 'unsupportedDocType') {
      return i18n.t('unsupportedDocType', { fileTypes });
    }

    return i18n.t(errorText);
  }

  const error = getTranslatedError(errorText);

  return (
    <TableRow className={classes.row} key={docSpec.uuid}>
      <CustomTableCell component="th" scope="row">
        {`${toActiveLocale(docSpec, lang)}${type === 0 ? '*' : ''}`}
      </CustomTableCell>
      <CustomTableCell>{doc ? doc.filename : ''}</CustomTableCell>
      {!readOnly && (
        <CustomTableCell>
          <input
            ref={inputEl}
            id="file"
            type="file"
            name="file"
            onChange={e => handleFileUpload(e, docSpec.uuid, docSpec.code)}
            className={classes.file}
          />
          <button
            className={classes.uploadButton}
            onClick={() => {
              inputEl.current.click();
            }}
          >
            {t('pleaseChooseFile')}
          </button>
          {isError && <FormHelperText error={isError}>{error}</FormHelperText>}
          {docSpec.code === '481' ? (
            <label className={classes.fileLabel} htmlFor="file">
              {t('imageFileTypeLabel', { pictureFileTypes })}
            </label>
          ) : (
            <label className={classes.fileLabel} htmlFor="file">
              {t('fileTypeLabel', { fileTypes })}
            </label>
          )}
        </CustomTableCell>
      )}
    </TableRow>
  );
}

export default DocumentsRow;

const CustomTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);



// WEBPACK FOOTER //
// ./src/view/forms/Application/SupportingDocuments/DocumentsRow.jsx